import { render, staticRenderFns } from "./dataPiceker.vue?vue&type=template&id=c2e3fb04&scoped=true"
import script from "./dataPiceker.vue?vue&type=script&lang=js"
export * from "./dataPiceker.vue?vue&type=script&lang=js"
import style0 from "./dataPiceker.vue?vue&type=style&index=0&id=c2e3fb04&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e3fb04",
  null
  
)

export default component.exports